<template>
  <div>
    <div class="d-flex">
      <div class="mr-auto">
        <button class="btn btn-secondary" @click="refresh">
          <i class="fas fa-sync-alt fa-fw"></i>
        </button>
      </div>
      <div class="align-self-end">
        <input-debounced
            v-model="search"
            :clearable="true"
            :autofocus="true"
            placeholder="Search"
            class="search-bar w-300 mb-2"
        ></input-debounced>
      </div>
    </div>
    <base-table
        :base-url="urlWithFilters"
        ref="baseTable"
        @load-success="onLoadSuccess"
        @refresh="onRefresh"
        :current-page="currentPage"
        v-loading="isRefreshing"
        element-loading-spinner="el-icon-loading"
    >
      <template v-slot>
        <el-table
            :data="items"
            stripe
            class="w-100"
        >
          <el-table-column
              prop="model.id"
              label="Id"
              min-width="50"
          ></el-table-column>
          <el-table-column
              prop="model.event_text"
              label="Event"
              min-width="50"
          ></el-table-column>
          <el-table-column
              prop="model.contact.presentation"
              label="Contact"
              min-width="150"
          ></el-table-column>
          <el-table-column
              prop="model.brand.title"
              label="Brand"
              min-width="80"
          ></el-table-column>
          <el-table-column
              prop="model.outgoing_number.phone_number"
              label="Outgoing Number"
              min-width="120"
          ></el-table-column>
          <el-table-column
              prop="model.created_at"
              label="Created"
              min-width="80"
              :formatter="formatDate"
          ></el-table-column>
        </el-table>
      </template>
    </base-table>
    <el-pagination
        layout="prev, pager, next"
        :total="total"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        class="text-right"
    ></el-pagination>
  </div>
</template>

<script>
import BaseTable from '../../../components/opt-event/table';

export default {
  extends: BaseTable,

  components: {
    // ...
  },

  props: {
    // ...
  },

  created() {
    eventBus.$on('refresh-opt-event-table', this.refresh);
  },

  beforeDestroy() {
    eventBus.$off('refresh-opt-event-table', this.refresh);
  }
}
</script>
